export default __webpack_public_path__ + "static/media/land-1.83f1f513.jpg";